import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetGstr1 } from '../../store/slices/reports';
import Loader from '../../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../../common/Table';
import AdminLayout from '../AdminLayout';
import { toast } from 'react-hot-toast';
import { FaFileExcel } from "react-icons/fa";
import { excelGSTR1Download } from "../../common/ExcelDownload"

const GSTR1 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [Gstr1, setGSTR1] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);  // Stores selected row IDs
  const [selectAll, setSelectAll] = useState(false);
  const [columns, setColumns] = useState([
    { header: 'Invoice Number', field: 'InvoiceNo' },
    { header: 'Invoice Date', field: 'InvoiceDate' },
    { header: 'Party GSTIN', field: 'PartyGSTIN' },
    { header: 'Party', field: 'PartyName' },
    { header: 'Billing State', field: 'BillingState' },
    { header: 'Shipping State', field: 'ShippingState' },
    { header: 'Product', field: 'name' },
    { header: 'HSN', field: 'hsn' },
    { header: 'Invoice Value', field: 'InvoiceValue' },
    { header: 'Taxable Value', field: 'TaxableValue' },
    { header: 'Tax Rate', field: 'TaxRate' },
    { header: 'CGST Amount', field: 'CGSTAmount' },
    { header: 'SGST Amount', field: 'SGSTAmount' },
    { header: 'IGST Amount', field: 'IGSTAmount' },
    { header: 'Total Tax Amount', field: 'TotalTaxAmount' },
    { header: 'Item Total', field: 'ItemTotal' },
    // {
    //   header: 'Actions',
    //   field: 'actions',
    //   isAction: true,
    //   actionButtons: [
    //     { name: 'Edit', className: 'btn-default' },
    //     { name: 'Delete', className: 'btn-cancel' },
    //     {
    //       className: 'btn-danger',
    //       icon: <FaFilePdf style={{ fontSize: '15px' }} />,
    //     },
    //   ],
    // },
  ]);

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');


  // Load saved financial year and dates from localStorage
  const loadSavedDates = () => {
    const savedFinancialYear = localStorage.getItem('selectedFinancialYear');

    // Ensure financial year is always correctly structured
    let startYear, endYear;
    if (savedFinancialYear && savedFinancialYear.includes('-')) {
      [startYear, endYear] = savedFinancialYear.split('-');
    } else {
      // Default to the current financial year
      const currentYear = new Date().getFullYear();
      startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
      endYear = currentYear;       // Example: 2025 (for 2024-2025)
    }

    return {
      financialYear: savedFinancialYear || `${startYear}-${endYear}`,
      fromDate: localStorage.getItem('savedFromDate') || `${startYear}-04-01`,
      toDate: localStorage.getItem('savedToDate') || `${endYear}-03-31`,
      minDate: `${startYear}-04-01`,
      maxDate: `${endYear}-03-31`,
    };
  };


  const { fromDate: initialFromDate, toDate: initialToDate, minDate, maxDate, financialYear: initialFinancialYear } = loadSavedDates();

  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);
  const [financialYear, setFinancialYear] = useState(initialFinancialYear);


  useEffect(() => {
    if (!financialYear) return;

    localStorage.setItem('selectedFinancialYear', financialYear);

    let startYear, endYear;
    if (financialYear.includes('-')) {
      [startYear, endYear] = financialYear.split('-');
    } else {
      return; // Exit if financial year is not valid
    }

    const savedFromDate = localStorage.getItem('savedFromDate') || `${startYear}-04-01`;
    const savedToDate = localStorage.getItem('savedToDate') || `${endYear}-03-31`;

    setFromDate(savedFromDate);
    setToDate(savedToDate);

    if (!localStorage.getItem('savedFromDate')) localStorage.setItem('savedFromDate', savedFromDate);
    if (!localStorage.getItem('savedToDate')) localStorage.setItem('savedToDate', savedToDate);
  }, [financialYear]);


  const fetchGstr1 = async () => {
    setIsLoading(true);
    const params = {
      profile_id: id,
      from_date: fromDate,
      to_date: toDate,

    };
    // console.log(params)
    try {
      const data = await dispatch(GetGstr1(params)).unwrap();
      setIsLoading(false);
      setGSTR1(data?.gstr1_report);
      console.log(data?.gstr1_report);
    } catch (error) {
      setIsLoading(false);
      setGSTR1([]);
      console.log('Error fetching invoices:', error.message);
    }
  };


  useEffect(() => {
    fetchGstr1();
  }, [financialYear]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  //   const handleEdit = (item) => {
  //     navigate(`/Updateaddinvoice/${item.id ? item.id : null}`);
  //   };

  //   const handleDelete = (item) => {
  //     const confirmDelete = window.confirm('Are you sure you want to delete this invoice?');
  //     if (confirmDelete) {
  //       setIsLoading(true);
  //       dispatch(invoicesDelete({ id: item.id }))
  //         .unwrap()
  //         .then(() => {
  //           setIsLoading(false);
  //           fetchInvoices(); // Refresh the invoice list
  //         })
  //         .catch(({ message }) => {
  //           setIsLoading(false);
  //           console.log(message);
  //         });
  //     }
  //   };

  //   const handlePDF = (item) => {
  //     const data = `${API_BASE_URL}${API_PATHS.invoicespdf}/${item?.id}`;
  //     navigate('/Pdf-Viewer', { state: { data } });
  //   };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();

    // Save dates in local storage
    localStorage.setItem('profitLossFromDate', fromDate);
    localStorage.setItem('profitLossToDate', toDate);

    fetchGstr1();
  };


  const filteredItemList = Gstr1?.filter((party) =>
    [
      party?.InvoiceNo,
      party?.FinancialYear,
      party?.PartyGSTIN,
      party?.PartyName,
      party?.BillingState,
      party?.ShippingState,
      party?.name,
      party?.hsn,
      party?.InvoiceValue,
      party?.TaxableValue,
      party?.TaxRate,
      party?.CGSTAmount,
      party?.SGSTAmount,
      party?.IGSTAmount,
      party?.TotalTaxAmount,
      party?.ItemTotal,
    ].some((value) =>
      value?.toString()?.toLowerCase()?.includes(searchQuery?.toLowerCase())
    )
  );



  const handleExcelDownload = () => {
    try {
      excelGSTR1Download(filteredItemList, "GSTR1.xlsx");
      toast.success("Downloading Excel file successfully!");
    } catch (error) {
      console.error("Error downloading Excel file:", error);
      alert("Failed to download the Excel file. Please try again.");
    }
  };


  const handleFromDateChange = (e) => {
    const newDate = e.target.value;
    if (newDate >= minDate && newDate <= maxDate) {
      setFromDate(newDate);
      localStorage.setItem('savedFromDate', newDate);
    } else {
      toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
    }
  };

  const handleToDateChange = (e) => {
    const newDate = e.target.value;
    if (newDate >= minDate && newDate <= maxDate) {
      setToDate(newDate);
      localStorage.setItem('savedToDate', newDate);
    } else {
      toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
    }
  };

  const formatFinancialYear = (startDate, endDate) => {
    return `(${startDate.split("-").reverse().join("-")} to ${endDate.split("-").reverse().join("-")})`;
  };

  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">GSTR1</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Reports</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  GSTR1
                </li>
              </ol>
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn ripple btn-default" onClick={handleExcelDownload} >
                Export Excel <FaFileExcel />
              </button>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <div class="card custom-card">
                <div class="card-body">
                  <form onSubmit={handleFilterSubmit} className="row mb-4">
                    <div className="col-md-4">
                      <label>From Date</label>
                      <input type="date" className="form-control" value={fromDate} onChange={handleFromDateChange} min={minDate} max={maxDate} />
                    </div>
                    <div className="col-md-4">
                      <label>To Date</label>
                      <input type="date" className="form-control" value={toDate} onChange={handleToDateChange} min={minDate} max={maxDate} />
                    </div>
                    <div className="col-md-4 mt-2">
                      <button type="submit" className="btn btn-default mt-4">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              {/* <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}> */}
              <Table
                columns={columns}
                data={filteredItemList}
                tableRef={tableRef}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                totalCount={filteredItemList?.length}
                onPageChange={handlePageChange}
                handleSearchChange={handleSearchChange}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default GSTR1;
